import fetchLocation from "utils/fetch-locations"
import fetchSocialMedia from "utils/fetch-social-media"
import Layout from "../components/Layout"
import PageHero from "../components/PageHero"
import DynamicContent from "../components/content/DynamicContent"
import { createApolloClient } from "../utils/apollo"
import { buildListQuery } from "../utils/blueprints/jobs"
import fetchCompany from "../utils/fetch-company"
import fetchNav from "../utils/fetch-nav"
import fetchPage from "../utils/fetch-page"
import { replaceVariables } from "../utils/replaceVariables"
import JobsList from "components/Jobs"

function Jobs({ jobs, navs, company, content, locations, socialMediaLinks }) {
  return (
    <Layout
      navs={navs}
      company={company}
      content={content}
      locations={locations}
      socialMediaLinks={socialMediaLinks}
    >
      <PageHero data={content} />
      <DynamicContent content={content} />
      <JobsList data={{ job_entries: jobs }} />
    </Layout>
  )
}

// Data for current page
// export const getServerSideProps = async (context) => {
export const getStaticProps = async (context) => {
  const { previewData } = context
  const apollo = createApolloClient(previewData?.token ?? null)

  const [jobsData, navs, company, locations, socialMediaLinks, content] =
    await Promise.all([
      apollo.query({
        query: buildListQuery(),
      }),
      fetchNav(apollo, previewData?.unit),
      fetchCompany(apollo, previewData?.unit),
      fetchLocation(apollo, previewData?.unit),
      fetchSocialMedia(apollo, previewData?.unit),
      fetchPage({ apollo, slug: "jobs", isPreview: previewData?.unit }),
    ])

  if (content?.errors?.length) {
    throw new Error(content.errors[0]?.message)
  }

  if (jobsData.errors?.length) {
    throw new Error(jobsData.errors[0]?.message)
  }

  const jobs = (jobsData.data.entries.data || []).filter((e) => !!e)

  if (!jobs.length && !content) {
    return { notFound: true }
  }

  return {
    props: {
      jobs,
      navs,
      company,
      locations,
      socialMediaLinks,
      content: content ? await replaceVariables(content) : {},
    },
    // revalidate: 30,
  }
}

export default Jobs
